<template>
  <div id="player">
    <div class="ui container">
      <Thumbnail
        v-if="!playing"
        id="player-thumb"
        class="fluid"
        :syncguid="syncguid"
        @play="playVideo"
      />
      <AICCVideoPlayer
        v-show="playing"
        ref="videoPlayer"
        :syncguid="syncguid"
        @play="playing = true"
        v-if="showAICC"
        @showQuizModal="$emit('showQuizModal')"
      />
      <SCORM12
        v-show="playing"
        ref="videoPlayer"
        :syncguid="syncguid"
        @play="playing = true"
        v-if="showSCORM12"
        @showQuizModal="$emit('showQuizModal')"
      />
      <SCORM2004
        v-show="playing"
        ref="videoPlayer"
        :syncguid="syncguid"
        @play="playing = true"
        v-if="showSCORM2004"
        @showQuizModal="$emit('showQuizModal')"
      />
    </div>
  </div>
</template>

<script>
import Thumbnail from '@/components/profile/Thumbnail';
import AICCVideoPlayer from '@/components/shared/standards/AICCVideoPlayer';
import SCORM12 from '@/components/shared/standards/SCORM12VideoPlayer';
import SCORM2004 from '@/components/shared/standards/SCORM2004VideoPlayer';

export default {
  name: 'Player',
  components: {
    Thumbnail,
    AICCVideoPlayer,
    SCORM12,
    SCORM2004,
  },
  props: ['standard'],
  data() {
    return {
      playing: false,
    };
  },
  computed: {
    syncguid() {
      return this.$route.params.syncguid;
    },
    showAICC() {
      return this.standard === 'AICC';
    },
    showSCORM12() {
      return this.standard === 'SCORM_12';
    },
    showSCORM2004() {
      return this.standard === 'SCORM_2004';
    },
  },
  methods: {
    playVideo() {
      this.playing = true;
      this.$refs.videoPlayer.play();
    },
  },
  mounted() {
    window._tracking = {
      launch: () => {
        this.$refs.videoPlayer.init();
      },
      startVideo: () => {
        this.playVideo();
      },
      saveProgress: () => {
        this.$refs.videoPlayer.saveProgress();
      },
      finishVideo: () => {
        this.$refs.videoPlayer.seek(this.$refs.videoPlayer.duration);
      },
      submitQuiz: (score, passed) => {
        if (this.$refs.videoPlayer.hasQuiz) {
          this.$refs.videoPlayer.submitQuiz({ passed, score });
        }
      },
      completeCourse: () => {
        this.$refs.videoPlayer.complete();
      },
      exit: () => {
        this.$refs.videoPlayer.exitSession();
      },
    };
  },
};
</script>

<style lang="less" scoped>
#player {
  width: 100vw;
  background-color: #000;
  #player-thumb {
    display: block;
    margin: 0 auto;
  }
}
</style>
